import type { TFunction } from 'i18next'
import type { PromoCampaignErrorRow } from '../model/types'

import { pickAll } from 'lodash/fp'
import { AlertTriangleIcon } from 'lucide-react'
import { toast } from 'sonner'

import { ampli } from '@/shared/lib/ampli'
import Sentry from '@/shared/lib/sentry'
import { download } from '@/shared/tools/report'

import buildPromoErrorFileBlob from './buildPromoErrorFileBlob'

export function buildPromoCampaignErrorFileHandler(t: TFunction) {
	return async (errors: Record<string, PromoCampaignErrorRow[]>) => {
		ampli.promoDownloadErrors()
		try {
			const rows = Object.values(errors)
				.reduce((acc, list) => [...acc, ...list], [])
				.map(pickAll(['pricing_tier_id', 'sku', 'reason']))
			const blob = await buildPromoErrorFileBlob(rows)
			download(blob, 'promo_errors.xlsx')
		} catch (error) {
			Sentry.captureException(error)
			toast(t('fatal_error_title'), {
				icon: <AlertTriangleIcon className='text-warning' />,
				duration: 5000,
			})
		}
	}
}
